import type { TrackingInfoRequest } from "@/type";

const STORAGE_KEY = "track_page_search_query";

export type SearchQueryType = "order" | "tracking";

export interface StoredSearchQuery {
  type: SearchQueryType;
  shop?: string;
  lang?: string;
  country?: string;
  order?: string;
  email?: string;
  tracking_number?: string;
}

export function getUrlSearchContext() {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    shop: searchParams.get("shop") || "looxtrackdev1.myshopify.com",
    lang: searchParams.get("lang") || "en",
    country: searchParams.get("country") || undefined,
  };
}

export function saveSearchQuery(query: StoredSearchQuery): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(query));
  } catch {
    // 忽略存储失败（隐私模式等）
  }
}

export function getSearchQuery(): StoredSearchQuery | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredSearchQuery;
    if (parsed?.type === "order" && parsed.order && parsed.email) return parsed;
    if (parsed?.type === "tracking" && parsed.tracking_number) return parsed;
    return null;
  } catch {
    return null;
  }
}

export function clearSearchQuery(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function storedToRequest(stored: StoredSearchQuery): TrackingInfoRequest {
  return {
    shop: stored.shop,
    lang: stored.lang,
    country: stored.country,
    order: stored.order,
    email: stored.email,
    tracking_number: stored.tracking_number,
  };
}
